import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { MenuItem } from '@mui/material';

import { BLACK, PRIMARY_PURPLE } from '../../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../../theme/fontConstants';
import { DOCUMENT_VALIDITY_STATUSES } from '../constants';
import { canSetValidityStatus, FORM_VALIDITY_OPTIONS } from '../documentReview';

const VALIDITY_OPTION_ICONS = {
  [DOCUMENT_VALIDITY_STATUSES.VALID]: CheckCircleIcon,
  [DOCUMENT_VALIDITY_STATUSES.INVALID]: CancelIcon,
};

const formValidityMenuItemSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 1.5,
  minWidth: '180px',
  fontFamily: PRIMARY_FONT[400],
  fontSize: '14px',
  color: BLACK[100],
  py: 1,
  px: 1.5,
};

const FormValidityMenuItems = ({ document, onSelect }) =>
  FORM_VALIDITY_OPTIONS.map((option) => {
    const isEnabled = canSetValidityStatus(document, option.status);
    const isSelected = document?.validity?.status === option.status;
    const Icon = VALIDITY_OPTION_ICONS[option.status];

    return (
      <MenuItem
        key={option.status}
        disabled={!isEnabled}
        selected={isSelected}
        onClick={isEnabled ? () => onSelect(option.status) : undefined}
        sx={{
          ...formValidityMenuItemSx,
          ...(isSelected && { backgroundColor: PRIMARY_PURPLE[20] }),
          '&.Mui-selected': {
            backgroundColor: PRIMARY_PURPLE[20],
          },
          '&:hover': {
            backgroundColor: isSelected ? PRIMARY_PURPLE[20] : PRIMARY_PURPLE[10],
          },
          '&.Mui-selected:hover': {
            backgroundColor: PRIMARY_PURPLE[20],
          },
        }}
      >
        <Icon sx={{ color: option.iconColor, fontSize: '18px', flexShrink: 0 }} />
        {LanguageConverterV2(option.labelKey)}
      </MenuItem>
    );
  });

FormValidityMenuItems.propTypes = {
  document: PropTypes.shape({
    _id: PropTypes.string,
    state: PropTypes.shape({ status: PropTypes.string }),
    validity: PropTypes.shape({ status: PropTypes.string }),
  }).isRequired,
  onSelect: PropTypes.func,
};

FormValidityMenuItems.defaultProps = {
  onSelect: () => {},
};

export default FormValidityMenuItems;
